import { SearchTermAdapter } from "../../ls/LSSearch";
import {
  isReadingLevelSearch,
  ReadingLevelSearchTerm,
} from "../AdvancedSearchTerm";

export const readingLevelSearchAdapter: SearchTermAdapter<ReadingLevelSearchTerm> =
  {
    getTerm: function (sp: URLSearchParams): ReadingLevelSearchTerm {
      try {
        const termParam = sp.get("term");
        if (!termParam) {
          return null;
        }

        const term = JSON.parse(termParam);
        if (isReadingLevelSearch(term)) {
          return term;
        }
        return null;
      } catch (e: unknown) {
        return null;
      }
    },
    toApiString: function ({
      isAnd,
      isReadingLevel,
      searchTokens,
    }: ReadingLevelSearchTerm): string {
      return JSON.stringify({ isAnd, isReadingLevel, searchTokens });
    },
    setTerm: function (
      sp: URLSearchParams,
      term: ReadingLevelSearchTerm
    ): URLSearchParams {
      sp.set("term", JSON.stringify(term));
      return sp;
    },
  };
